import type { ReportChartGroupItemMeasure } from '../../../../interfaces/report-chart-group-item-measure';

export const CatiChart1Measures: ReportChartGroupItemMeasure[] = [
  {
    type: 'cati',
    items: ['cati-metrics'],
  },
];
